import { call, put, takeEvery } from "redux-saga/effects"

// Login Redux States
import { GET_CURRENT_USER, LOGIN_USER, LOGOUT_USER } from "./actionTypes"
import { apiError, getCurrentUserError, getCurrentUserSuccess, loginSuccess, logoutUserSuccess } from "./actions"
import jwt_decode from "jwt-decode";

import { AppConfiguration } from "config"

//Include Both Helper File with needed methods
import {
  postJwtLogin,
  getCurrentUser
} from "../../../helpers/sf_backend_helper"
import { bsh_clearAdminUserDetails, bsh_clearInsuranceIoUserDetails, STORAGE_KEY } from "helpers/sf_browser_storage_helper";
import { OTP_STRINGS } from "helpers/sf_constants";


function* loginUser({ payload: { user, history } }) {
  try {
    let data = {
      email: user.email,
      password: user.password
    }
    if (user.otp !== "") {
      data = {
        ...data,
        otp: user.otp
      }
    }
    const response = yield call(
      postJwtLogin,
      `${AppConfiguration.BACKEND_URL}/api/v1/login`,
      data
    )

    let authUser = { user: { token: response.data.token, account_id: response.data.memberships[0].account.id } }
    localStorage.setItem("authUser", JSON.stringify(authUser))
    localStorage.removeItem("current_brand")
    if (user.remember_me === false) {
      window.onbeforeunload = function () {
        //TODO: Fix issue where it gets logged out in the same browser session
        //localStorage.clear();
      }
      yield put(loginSuccess(response.data))
    }

    history.push("/")
  } catch (error) {
    if (error === OTP_STRINGS.authenticator_message || error === OTP_STRINGS.email_message) {
      history.push(`/login?email=${user.email}&showOtp="true"`)
    }
    yield put(apiError(error))
  }
}

function* logoutUser({ payload: { history } }) {
  try {

    localStorage.removeItem("authUser")
    bsh_clearAdminUserDetails();
    bsh_clearInsuranceIoUserDetails();

    localStorage.removeItem(STORAGE_KEY.FILTERS.NAME)
    yield put(logoutUserSuccess())
    if (history?.redirect_url) {
      window.location.assign("/" + history?.redirect_url)
    }
    else {
      window.location.assign("/login")
    }
  } catch (error) {
    yield put(apiError(error))
  }
}

function* onGetCurrentUser({ payload: { history } }) {
  try {
    let token = JSON.parse(localStorage.getItem('authUser')).user.token;
    let decodedToken = jwt_decode(token.split(" ")[1]);

    const response = yield call(
      getCurrentUser,
      `${AppConfiguration.BACKEND_URL}/api/v1/users/profiles/${decodedToken.sub}`,
      {
        token: token
      }
    )
    yield put(getCurrentUserSuccess(response))
  } catch (error) {
    yield put(getCurrentUserError(error))
    localStorage.removeItem('authUser');
  }
}

function* authSaga() {
  yield takeEvery(LOGIN_USER, loginUser)
  yield takeEvery(LOGOUT_USER, logoutUser)
  yield takeEvery(GET_CURRENT_USER, onGetCurrentUser)
}

export default authSaga
